import React, { createContext, useContext, useMemo } from 'react';
import { createSelfServiceClient, SelfServiceClient } from './selfServiceClient';

export const SelfServiceContext = createContext<SelfServiceClient>({
  exportData: () => Promise.reject(),
  updatePONumber: () => Promise.reject(),
  getLicenseUsageChartData: () => Promise.reject(),
  getLicenseUsageTableData: () => Promise.reject(),
  getSubscriptionManagerMetrics: () => Promise.reject(),
  getLicenseActiveUsersTableData: () => Promise.reject(),
  getToken: () => Promise.reject(),
  getAllSubscriptions: () => Promise.reject(),
  getApplicationParts: () => Promise.reject(),
  getDebitMemos: () => Promise.reject(),
  getInvoices: () => Promise.reject(),
  getSubscription: () => Promise.reject(),
  getPaymentProvider: () => Promise.reject(),
});

export const SelfServiceProvider: React.FC<{ value?: SelfServiceClient }> = (props) => {
  const value = useMemo(createSelfServiceClient, []);

  return <SelfServiceContext.Provider value={value} {...props} />;
};

export const useSelfService = () => useContext(SelfServiceContext);
